<body class="body popup-loader counter-scroll">
  <div id="wrapper">

    <div class="page-title">
      <div class="tf-tsparticles">
        <div id="tsparticles1" data-color="#fff" data-line="#fff"></div>
      </div>
      <div class="tf-container">
        <div class="row">
          <div class="col-12">
            <div class="content">
              <h1 class="title">Confirm your new password</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="main-content-dashboard-wrap">
    <div class="main-content-dashboard gap62">

      <!-- my account profile -->
      <div class="my-account-profile">
        <div class="tf-container">
          <div class="row">
            <div class="col-lg-12">
              <div class="profile-infor">
                <div class="edit-infor">

                  <form id="form-security-change-psw" class="form-security" [formGroup]="completePasswordForgotForm">
                    <div class="cols mb-30 relative has-verified z-5">
                      <fieldset>
                        <label for="password">New password</label>
                        <input [type]="isNewPasswordVisible ? 'text' : 'password'" placeholder="Password"
                          formControlName="password"
                          [class.is-invalid]="completePasswordForgotForm.get('password')?.invalid && completePasswordForgotForm.get('password')?.touched">
                        <span class="toggle-password first-time" (click)="toggleNewPasswordVisibility()"
                          (keydown)="toggleNewPasswordVisibility()" tabindex="0" role="button">
                          <i class="icon-view"></i>
                        </span>
                        <div *ngIf="completePasswordForgotForm.get('password')?.errors" class="invalid-feedback">
                          <div *ngIf="completePasswordForgotForm.get('password')?.errors?.['required']">Mandatory field
                          </div>
                          <div *ngIf="completePasswordForgotForm.get('password')?.errors?.['minlength']">Password not
                            strong enough
                          </div>
                        </div>
                      </fieldset>
                      <br><br>
                      <div class="cols mb-30 relative has-verified z-5">
                        <fieldset>
                          <label for="confirmPassword">Confirm new password</label>
                          <input [type]="isConfirmNewPasswordVisible ? 'text' : 'password'" placeholder="Password"
                            formControlName="confirmPassword"
                            [class.is-invalid]="completePasswordForgotForm.get('confirmPassword')?.invalid && completePasswordForgotForm.get('confirmPassword')?.touched">
                          <span class="toggle-password first-time" (click)="toggleConfirmNewPasswordVisibility()"
                            (keydown)="toggleConfirmNewPasswordVisibility()" tabindex="0" role="button">
                            <i class="icon-view"></i>
                          </span>
                          <div *ngIf="completePasswordForgotForm.get('confirmPassword')?.errors"
                            class="invalid-feedback">
                            <div *ngIf="completePasswordForgotForm.get('confirmPassword')?.errors?.['required']">
                              Mandatory
                              field</div>
                          </div>
                          <div *ngIf="completePasswordForgotForm.get('password')?.errors?.['minlength']">Password not
                            strong enough
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="heading-left" style="display:flex; align-items:center; justify-content: center;">
                  <button type="button" form="form-infor"
                    [ngClass]="{ 'style-1': completePasswordForgotForm.valid, 'style-3': !completePasswordForgotForm.valid }"
                    [disabled]="!completePasswordForgotForm.valid" class="tf-btn pd-0-46" (click)="onSubmit()">
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>